var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBogoPitchers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 40.62H41.385V43.05C41.385 43.28 41.275 43.395 41.055 43.395H39.93C39.7 43.395 39.585 43.28 39.585 43.05V40.62H37.185C36.955 40.62 36.84 40.51 36.84 40.29V39.36C36.84 39.13 36.955 39.015 37.185 39.015H39.585V36.615C39.585 36.385 39.7 36.27 39.93 36.27H41.055C41.275 36.27 41.385 36.385 41.385 36.615V39.015H43.8C44.03 39.015 44.145 39.13 44.145 39.36V40.29C44.145 40.51 44.03 40.62 43.8 40.62Z",
    fill: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4067 28.5H67.2645V56C67.2645 58.4853 65.2498 60.5 62.7645 60.5H51.9067C49.4215 60.5 47.4067 58.4853 47.4067 56V28.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8069 21.6902C44.8168 23.2902 45.736 28 47.5497 28.5H51.8924V35.5C51.8924 38.5 54.9114 39 55 36V28.5H67.5006C70.2211 25.5 67.954 21.1902 64.677 21.1902C64.3142 19.5902 62.4521 19.1902 61.503 19.6902C59.3265 16.8902 56.3641 18.1902 55.155 19.1902C51.5275 17.5902 49.4115 20.1902 48.8069 21.6902Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5471 32.5H70.2088C72.6941 32.5 74.7088 34.5147 74.7088 37V43C74.7088 45.4853 72.6941 47.5 70.2088 47.5H67.5471V32.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5471 34.5H70.3951C71.7758 34.5 72.8951 35.6193 72.8951 37V43C72.8951 44.3807 71.7758 45.5 70.3951 45.5H67.5471V34.5Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8022 28.5H13.9445V56C13.9445 58.4853 15.9592 60.5 18.4445 60.5H29.3022C31.7875 60.5 33.8022 58.4853 33.8022 56V28.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.402 21.6902C36.3922 23.2902 35.473 28 33.6593 28.5H29.3166V35.5C29.3166 38.5 26.0887 39 26.0001 36V28.5H13.7084C10.9878 25.5 13.255 21.1902 16.532 21.1902C16.8948 19.5902 18.7569 19.1902 19.706 19.6902C21.8825 16.8902 24.8449 18.1902 26.054 19.1902C29.6815 17.5902 31.7975 20.1902 32.402 21.6902Z",
    fill: "white",
    stroke: "#103B5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6619 32.5H11.0001C8.51486 32.5 6.50014 34.5147 6.50014 37V43C6.50014 45.4853 8.51486 47.5 11.0001 47.5H13.6619V32.5Z",
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6619 34.5H10.8139C9.43315 34.5 8.31386 35.6193 8.31386 37V43C8.31386 44.3807 9.43315 45.5 10.8139 45.5H13.6619V34.5Z",
    fill: "white",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBogoPitchers);
export default __webpack_public_path__ + "static/media/BOGO_Pitchers.80586ad8a55ea1e7b651da618f2dc189.svg";
export { ForwardRef as ReactComponent };